module.exports = __webpack_public_path__ + "img/imgVirtualTryOn01.8de72dda.png";